export const  FormatType =  {
  bold: 'BOLD',
  italic: 'ITALIC',
  normal: 'NORMAL',
  uppercase: 'UPPERCASE'
}
